import { takeEvery, call, select } from 'redux-saga/effects';

import { ACTIVE_VENUE_CHANGED } from 'features/App/App.saga';
import { makePath } from 'helpers/link-generation';
import { selectActiveVenueId } from 'selectors/general';

import {
  EMAIL_ORDER_CUSTOMER,
  emailOrderCustomer,
  doEmailOrderCustomer,
  watchEmailOrderCustomer,
} from '../shared/SkuEmailOrderCustomer.saga';

export { EMAIL_ORDER_CUSTOMER, emailOrderCustomer, doEmailOrderCustomer };

export function* handleActiveVenueChange(client, action) {
  const { venueId } = action;
  const activeVenueId = yield select(selectActiveVenueId);

  if (venueId !== activeVenueId) {
    yield call(client.navigate, makePath.orders(venueId));
  }
}

export function* watchActions(dependencies) {
  yield* watchEmailOrderCustomer(dependencies);
  yield takeEvery(ACTIVE_VENUE_CHANGED, handleActiveVenueChange, dependencies);
}
